import CustomForm from "../CustomForm";
import m, {Vnode} from "mithril";
import {Answer} from "./RTMCard";

export default abstract class RTM extends CustomForm {

    protected chosenAnswer: Answer|null = null;

    rewriteFormControls(): boolean {
        return true;
    }

    protected viewHintBar(): Vnode {

        const answerClass = this.chosenAnswer ? '.answer-'+this.chosenAnswer : '';

        return m('.bar.'+answerClass, {}, [
            m('i.cross'),
            m('i.arrow-left', {}, 'A'),
            m('i.card'),
            m('i.arrow-right', {}, 'L'),
            m('i.success'),
        ]);
    }

}